export default __webpack_public_path__ + "static/media/img_02.ec402aa4.png";